import React, { useState, useEffect, useCallback } from "react";
import {
	ProductViewRoundedCard,
	ProductViewSimilarProduct,
} from "../ProductViewCore";

import "./product-view-similar-card.css";

const similarProductMapper = (similarProducts) => {
	return Object.entries(similarProducts).reduce(
		(map, [, product]) => [...map, product],
		[]
	);
};

const ProductViewSimilarCard = React.memo(
	({
		product,
		similarProducts: _similarProducts,
		setProductViewData,
		navToTop,
		offsetTop,
		productViewEventProps,
	}) => {
		if (
			!_similarProducts ||
			!product ||
			Object.entries(_similarProducts).length === 0
		) {
			return;
		}

		const [similarProducts, setSimilarProducts] = useState(null);

		useEffect(() => {
			setSimilarProducts(similarProductMapper(_similarProducts));
		}, [_similarProducts]);

		const handleProductClick = useCallback(
			(_product) => {
				setProductViewData((productViewData) => {
					let _newSimilarProducts = {
						...productViewData.similar_products,
					};
					delete _newSimilarProducts[_product.remote_id];
					_newSimilarProducts[product.remote_id] = {
						...product,
					};

					return {
						...productViewData,
						product: _product,
						similar_products: _newSimilarProducts,
					};
				});
				if (navToTop && typeof navToTop === "function") {
					// scroll.scrollToTop();
					navToTop();
				}
			},
			[product, setProductViewData, navToTop]
		);

		if (!similarProducts) {
			return;
		}

		return (
			<ProductViewRoundedCard className="product-view-similar-card">
				<h2>Similar Products</h2>
				<section className="product-view-similar-products-container">
					{similarProducts.map((similarProduct, index) => (
						<ProductViewSimilarProduct
							product={similarProduct}
							handleProductClick={handleProductClick}
							key={`${similarProduct.name}_${index}`}
							offsetTop={offsetTop}
							activeProduct={product}
							idx={index}
							productViewEventProps={productViewEventProps}
						/>
					))}
				</section>
			</ProductViewRoundedCard>
		);
	}
);

export default ProductViewSimilarCard;
